export default {
    toolbar: [
        {
            class: "tool-item",
            title: "addFile", // add file
            fn: "beforeCreateProject",
            width: 20,
            height: 20,
            href: "#codelab-add",
        },
        {
            class: "tool-item",
            title: "saveFile", // save file
            fn: "beforSaveBlock",
            width: 20,
            height: 20,
            href: "#codelab-save",
        },
        {
            class: "tool-item",
            title: "saveAnotherFile", // save another file
            fn: "beforSaveAnotherBlock",
            width: 20,
            height: 20,
            href: "#codelab-save-another",
        },
        // {
        //     class: "tool-item",
        //     title: "more",
        //     fn: "openMoreControl",
        //     width: 20,
        //     height: 20,
        //     href: "#codelab-icon-more",
        //     isSplit: true,
        // },
    ],
    quickEdit:[
        {
            title: "undo",
            fn: "undoBlocklyAction",
            href: "#codelab-undo",
            direction: "horizontal"
        },
        {
            title: "redo",
            fn: "redoBlocklyAction",
            href: "#codelab-redo",
            direction: "horizontal"
        },
        {
            title: "cut",
            fn: "cutBlocklyAction",
            href: "#codelab-icon-cut"
        },
        {
            title: "copy",
            fn: "copyBlocklyAction",
            href: "#codelab-icon-copy"
        },
        {
            title: "paste",
            fn: "pasteBlocklyAction",
            href: "#codelab-icon-paste"
        }
    ],
    editorTool: [
        {
            title: "locate_center",
            fn: "centerBlocklyAction",
            href: "#codelab-icon-center"
        },
        {
            title: "zoom_in",
            fn: "zoomInBlocklyAction",
            href: "#codelab-icon-zoom-in"
        },
        {
            title: "zoom_out",
            fn: "zoomOutBlocklyAction",
            href: "#codelab-icon-zoom-out"
        }
    ]
}
